export default __webpack_public_path__ + "static/media/provider.0df041b6.png";